// extracted by mini-css-extract-plugin
export default {"trade-count":"_1OvZP","tradeCount":"_1OvZP","download-icon":"_3J5k_","downloadIcon":"_3J5k_","resell-button-wrapper":"S1GUN","resellButtonWrapper":"S1GUN"};